/** Resolve the branch used by a branch-scoped request in the All view. */
export function concreteGarageId(activeGarageId, user) {
  if (activeGarageId === 'all') {
    try {
      return localStorage.getItem('lastRealGarageId') || user?.garage_id;
    } catch (_error) {
      return user?.garage_id;
    }
  }
  return activeGarageId || user?.garage_id;
}

/**
 * The Expense form's default branch (P2): the concrete active branch, or
 * empty in All mode so the branch must be chosen explicitly.
 */
export function expenseBranchDefault(activeGarageId, user) {
  if (activeGarageId === 'all') return '';
  const id = concreteGarageId(activeGarageId, user) || user?.garage?.id;
  return id ? String(id) : '';
}
